import { Search, Filter, Rank, Query } from 'api/grpc/resources';
import { grpcToRestSearch } from 'utils/grpc/grpcToRest';
import { fetch } from 'utils/request/apiRequest';

type FunctionBody = {
  userOrOrgId: string;
  appId: string;
  filters: Filter[];
  ranks: Rank[];
};

export async function fetchInputsCounts({ userOrOrgId, appId, filters, ranks }: FunctionBody): Promise<CF.API.Inputs.ListInputsCountsResponse> {
  const searches = new Search();
  const query = new Query();
  query.setFiltersList(filters);
  query.setRanksList(ranks);
  searches.setQuery(query);

  const restSearch = grpcToRestSearch(searches);

  return fetch({
    path: `/api/_api/v2/users/${userOrOrgId}/apps/${appId}/inputs/searches`,
    method: 'POST',
    body: {
      user_app_id: {
        user_id: userOrOrgId,
        app_id: appId,
      },
      searches: [restSearch],
      only_count: true,
    },
  });
}

export async function fetchInputsCountsSearches({
  userOrOrgId,
  appId,
  searches,
}: {
  userOrOrgId: string;
  appId: string;
  searches: Search[];
}): Promise<CF.API.Inputs.ListInputsCountsResponse> {
  const restSearch = searches.map(grpcToRestSearch);

  return fetch({
    path: `/api/_api/v2/users/${userOrOrgId}/apps/${appId}/inputs/searches`,
    method: 'POST',
    body: {
      user_app_id: {
        user_id: userOrOrgId,
        app_id: appId,
      },
      searches: restSearch,
      only_count: true,
    },
  });
}
